import autobind from "autobind-decorator";
import * as React from "react";
import ProgressiveImage from "react-progressive-image-loading";
import * as smoothScroll from "smoothscroll";

import { Card, CardContent, CardMedia, WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import { formatPrice, Kit } from "./kits";

import promo from "./Promo"
import Text from "./Text";

type ClassNames = "card" | "media" | "content" | "title";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    card: {
        margin: theme.spacing.unit * 2,
        cursor: "pointer",
        borderRadius: 5
    },
    media: {
        width: "100%",
        maxWidth: 400,
        height: 400 * 0.62,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5
    },
    content: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        maxWidth: 400,
        boxSizing: "border-box"
    },
    title: {
        flexGrow: 1,
        paddingRight: theme.spacing.unit * 2,
        textAlign: "left"
    }
});

interface ThumbnailProps {
    kit: Kit
}

class Thumbnail extends React.Component<WithStyles<ClassNames> & ThumbnailProps> {

    public renderImage = (src: string, style: React.CSSProperties) => (
        <CardMedia
            className={this.props.classes.media}
            image={src}
            title={this.props.kit.name}
            {...{ style }}
        />
    );

    public render() {
        const {kit, classes} = this.props;
        return (
            <Card className={classes.card} {...{ onClick: this.scroll }}>
                <ProgressiveImage
                    preview={kit.thumbnailPreview}
                    src={kit.thumbnail}
                    render={this.renderImage}
                />
                <CardContent className={classes.content}>
                    <div className={classes.title}>
                        <Text variant="title3">{kit.name}</Text>
                        <Text>{kit.overview}</Text>
                    </div>
                    <div>
                        {
                            promo.active && kit.price.originalPrice && (
                                <Text style={{ textDecoration: "line-through" }}>
                                    {formatPrice({ value: kit.price.originalPrice, currency: kit.price.currency })}
                                </Text>
                            )
                        }
                        {
                            !kit.price.originalPrice && (
                                <Text>{formatPrice(kit.price)}</Text>
                            )
                        }
                        {
                            promo.active && kit.price.originalPrice && (
                                <Text variant="important">{formatPrice(kit.price)}</Text>
                            )
                        }
                        {
                            !promo.active && kit.price.originalPrice && (
                                <Text>
                                  {formatPrice({ value: kit.price.originalPrice, currency: kit.price.currency })}
                                </Text>
                            )
                        }
                    </div>
                </CardContent>
            </Card>
        );
    }

    @autobind
    private scroll() {
        const {id} = this.props.kit;
        smoothScroll(document.getElementById(id));
    }
}

export default withStyles(styles)(Thumbnail);



// WEBPACK FOOTER //
// ./src/components/Thumbnail.tsx